import { useState } from "react";
import { SearchSectionForm } from "./SYS3060_R01Form";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
  autGroupOptions: SysCodeDto[];
  selectedSourceAutGroup: string;
  setSelectedSourceAutGroup: (value: string) => void;
  selectedTargetAutGroup: string;
  setSelectedTargetAutGroup: (value: string) => void;
  handleCopyClick?: () => void;
  onCopyComplete?: () => void;
}

export const CopySearchSection_SYS3060_R01 = ({
  selectedSourceAutGroup,
  setSelectedSourceAutGroup,
  selectedTargetAutGroup,
  setSelectedTargetAutGroup,
  handleCopyClick,
  onCopyComplete
}: Props) => {
  // 권한복사용 별도 상태 (SearchSection과 독립적)
  const [copySystemCd, setCopySystemCd] = useState<string>('');
//   const { systemOptions } = useSYS3060_R01Store();
	const { autGroupList, systemList } = useCommonCodeStore();
  
  const handleCopyButtonClick = async () => {
    if (handleCopyClick) {
        handleCopyClick();
      if (onCopyComplete) {
        onCopyComplete();
      }
    }
  };

  return (
    <SearchSectionForm>
      <SearchDropDownForm<SysCodeDto>
        label="권한그룹"
        value={selectedSourceAutGroup}
        optionList={autGroupList}
        onChangeValue={v => setSelectedSourceAutGroup(v === 'all' ? '' : v)}
      />
      <SearchDropDownForm<SysCodeDto>
        label="업무시스템"
        value={copySystemCd || 'all'}
        optionList={systemList}
        onChangeValue={v => setCopySystemCd(v === 'all' ? '' : v)}
      />
      <SearchDropDownForm<SysCodeDto>
        label="대상권한"
        value={selectedTargetAutGroup}
        optionList={autGroupList}
        onChangeValue={v => setSelectedTargetAutGroup(v === 'all' ? '' : v)}
      />
      <button
        className="bg-blue-dark text-white m-0 h-[27px] rounded-[4px] px-[16px] font-semibold hover:bg-blue-600"
        onClick={handleCopyButtonClick}
        type="button"
      >
        권한복사
      </button>
    </SearchSectionForm>
  );
}; 